import type { useRouter } from 'next/router';

import { affiliatesPageRouteWithSpecificAffIdAndSource } from '@src/shared/constants/pageRoutes';
import { getRoutePathParams } from '@src/utils/getRoutePathParams';
import { isExactMainPage } from '@src/utils/routing';

export function getPositionFromUrl(router: ReturnType<typeof useRouter>): string | undefined {
  const routeParams = getRoutePathParams(affiliatesPageRouteWithSpecificAffIdAndSource, router.asPath);
  if (routeParams?.source) {
    return routeParams.source;
  }
  if (isExactMainPage(router.asPath)) {
    return router?.query?.source as string;
  }

  return undefined;
}
